fragment RoutinesSportSliderFragment on routinesSportSlider_Entry {
  typeHandle
  heading
  sports: exercisesBlocksRoutineSports {
    ... on exercisesBlocksRoutineSportsBlock_Entry {
      id
      image {
        url
        title
      }
      alt
      cta {
        ...LinkFragment
      }
    }
  }
  position
}
